// extracted by mini-css-extract-plugin
module.exports = {"confirmSubscribe":"confirm-subscribe_confirmSubscribe__shc7r"};